/**
 * Helpers for creating Files instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { File } from "le-coffre-resources/dist/SuperAdmin";
import type { IRef } from "@Front/Api/BaseApiService";
import type { IGetFilesparams, IGetFileByUidParams, IPutFilesParams } from "../Files";
import {
	createGetMethod,
	createPostMethod,
	createGetUploadLinkMethod,
	createGetDownloadLinkMethod,
	createGetByUidMethod,
	createPutMethod,
	createDeleteMethod,
	createDownloadMethod,
	createDownloadMultipleMethod,
	createDownloadAggregatedCertificateMethod,
} from "./filesMethodsHelpers";

export interface FilesInstance {
	get(q: IGetFilesparams): Promise<File[]>;
	post(body: FormData): Promise<File>;
	getUploadLink(uid: string): string;
	getDownloadLink(uid: string, withCertificate?: boolean): string;
	getByUid(uid: string, q?: IGetFileByUidParams): Promise<File>;
	put(uid: string, body: IPutFilesParams): Promise<File>;
	delete(uid: string): Promise<File>;
	download(uid: string, withCertificate?: boolean, ref?: IRef): Promise<Blob>;
	downloadMultiple(fileUids: string[], includeAnchors?: boolean, folderNumber?: string, folderName?: string): Promise<Blob>;
	downloadAggregatedCertificate(documentUids: string[], folderUid: string): Promise<Blob>;
}

/**
 * Create Files instance with all methods
 */
export function createFilesInstance(baseNotary: IBaseNotary): FilesInstance {
	const baseUrl = baseNotary.namespaceUrl.concat("/files");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		getUploadLink: createGetUploadLinkMethod(baseUrl),
		getDownloadLink: createGetDownloadLinkMethod(baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
		delete: createDeleteMethod(baseNotary, baseUrl),
		download: createDownloadMethod(baseNotary, baseUrl),
		downloadMultiple: createDownloadMultipleMethod(baseNotary, baseUrl),
		downloadAggregatedCertificate: createDownloadAggregatedCertificateMethod(baseNotary, baseUrl),
	};
}
